import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import * as _ from 'underscore';

import { NavListService, NavListItem } from './nav-list.service';

const navOrder = ['dashboard', 'reports', 'event', 'orgEdit', 'editBrand', 'campaign', 'admin'];

export class NavController {
   version:string;
   year = new Date().getFullYear();

   navItems:NavListItem[];
   expanded:NavListItem;

   static $inject = ['$transitions', '$state', 'navList', 'session'];

   constructor(
      $transitions:uir.TransitionService,
      private $state:uir.StateService,
      private navList:NavListService,
      private session
   ) {
      this.version = this.session.appVersion();

      this.navItems = _.sortBy(this.navList.navItems, i => _.indexOf(navOrder, i.stateName));

      $transitions.onSuccess({}, transition => {
         // navigation can be triggered outside the navigation menu
         // need to handle updating state of expanded nav item reference
         this.updateExpanded();
      });
   }

   $onInit() {
      // on site load pre-expand parent nav item if active item is a child
      this.updateExpanded();
   }

   private updateExpanded() {
      for (let i of this.navItems) {
         if (i.children) {
            if (_.find(i.children, i => this.isActive(i))) {
               this.expanded = i;
               return;
            }
         }
      }

      // clear expanded item if active item is not a child item
      this.expanded = null;
   }

   isActive(item:NavListItem) {
      if (this.$state.is(item.stateName)) {
         return true;
      }

      if (item.otherStates && _.contains(item.otherStates, this.$state.current.name)) {
         return true;
      }

      return false;
   }

   isExpanded(item:NavListItem) {
      return this.expanded == item;
   }

   setExpanded(item:NavListItem) {
      this.expanded = item;
   }

   hiddenMobile(item:NavListItem) {
      return item.title == 'Reports' || item.title == 'Admin';
   }

   get showNav() { return this.navList.showNav; }
   set showNav(v) { this.navList.showNav = v; }
}

ng.module('e360').component('nav', {
   controller: NavController,
   templateUrl: require('./nav.html')
});
